import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "disabled"
}

import { shallowRef, watch } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'SvgLoader',
  props: {
    name: {},
    toolTipValue: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

// svgファイルをコンテキストとして読み込む
const svgModules = require.context('@/assets/svg', false, /\.svg$/);

// 現在表示するSVGのコンポーネント
const svg = shallowRef<Promise<any> | null>(null);

// 初期化 & 監視
const loadSvg = () => {
  const filePath = `./${props.name}.svg`;
  if (svgModules.keys().includes(filePath)) {
    svg.value = svgModules(filePath).default;
  } else {
    console.warn(`SVGファイルが見つかりません: ${filePath}`);
    svg.value = null;
  }
};

// watch
watch(() => props.name, loadSvg, { immediate: true });

/**
 * tooltip表示の有無を決める関数(とりあえず今は1文字以上あったら表示するくらいに)
 * @returns tooltip表示の有無
 */
const isDisplayTooltip = (): boolean => {
  return !!props.toolTipValue;
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.disabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(svg.value)))
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
      }, [
        (isDisplayTooltip())
          ? _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(svg.value), { key: 0 }, null, 512)), [
              [
                _directive_tooltip,
                props.toolTipValue,
                void 0,
                { bottom: true }
              ]
            ])
          : (_openBlock(), _createBlock(_resolveDynamicComponent(svg.value), { key: 1 }))
      ]))
}
}

})